<script>
import { connect } from 'vuex-connect';
import ErrorBox from '../scenes/ErrorBox.vue';

export default connect({
  actionsToEvents: {
    retry: 'initApp',
  },
})('ErrorBox', ErrorBox);
</script>
